function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1916(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 33.93,
    height: 22.72,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.7866666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 16.965,
    y: 11.36
  }, "\n        Camden\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 22.72,
    width: 33.93,
    height: 34.98,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.655
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 16.965,
    y: 40.209999999999994
  }, "\n        Chowan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 57.7,
    width: 33.93,
    height: 40.26,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.847142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 16.965,
    y: 77.83
  }, "\n        Tyrrell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 97.96,
    width: 33.93,
    height: 41.51,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.4825
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 16.965,
    y: 118.71499999999999
  }, "\n        Dare\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 139.47,
    width: 33.93,
    height: 42.5,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.4825
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 16.965,
    y: 160.72
  }, "\n        Clay\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 181.98,
    width: 33.93,
    height: 44.35,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.4825
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 16.965,
    y: 204.155
  }, "\n        Hoke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 226.32,
    width: 33.93,
    height: 46.54,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.393
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 16.965,
    y: 249.59
  }, "\n        Perquimans\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 272.86,
    width: 33.93,
    height: 46.64,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.655
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 16.965,
    y: 296.18
  }, "\n        Graham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 319.5,
    width: 33.93,
    height: 47.09,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.786
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 16.965,
    y: 343.045
  }, "\n        Jones\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 366.59,
    width: 33.93,
    height: 51.47,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.77
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 16.965,
    y: 392.325
  }, "\n        Currituck\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 418.07,
    width: 33.93,
    height: 53.57,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.24125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 16.965,
    y: 444.855
  }, "\n        Scotland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 471.63,
    width: 33.93,
    height: 56.01,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.4825
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 16.965,
    y: 499.635
  }, "\n        Hyde\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 527.64,
    width: 33.93,
    height: 56.56,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.786
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 16.965,
    y: 555.92
  }, "\n        Gates\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 584.2,
    width: 33.93,
    height: 56.66,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.393
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 16.965,
    y: 612.5300000000001
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 640.85,
    width: 33.93,
    height: 59.15,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.24125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 16.965,
    y: 670.4250000000001
  }, "\n        Hertford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 33.93,
    y: 0,
    width: 41.88,
    height: 47.92,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.982857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.870000000000005,
    y: 23.96
  }, "\n        Caswell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 75.8,
    y: 0,
    width: 44.28,
    height: 47.92,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.325714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 97.94,
    y: 23.96
  }, "\n        Pamlico\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 120.08,
    y: 0,
    width: 47.98,
    height: 47.92,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.986666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 144.07,
    y: 23.96
  }, "\n        Greene\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 168.06,
    y: 0,
    width: 48.33,
    height: 47.92,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.986666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 192.225,
    y: 23.96
  }, "\n        Pender\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 216.39,
    y: 0,
    width: 50.45,
    height: 47.92,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.98
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 241.61499999999998,
    y: 23.96
  }, "\n        Polk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 266.84,
    y: 0,
    width: 50.7,
    height: 47.92,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.3244444444444445
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 292.19,
    y: 23.96
  }, "\n        Alleghany\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 317.54,
    y: 0,
    width: 50.94,
    height: 47.92,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.986666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 343.01,
    y: 23.96
  }, "\n        Warren\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 368.48,
    y: 0,
    width: 51.08,
    height: 47.92,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.792
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 394.02000000000004,
    y: 23.96
  }, "\n        Pasquotank\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 419.57,
    y: 0,
    width: 53.62,
    height: 47.92,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.584
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 446.38,
    y: 23.96
  }, "\n        Avery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 473.19,
    y: 0,
    width: 55.14,
    height: 47.92,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.356363636363636
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 500.76,
    y: 23.96
  }, "\n        Northampton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 528.33,
    y: 0,
    width: 55.64,
    height: 47.92,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.986666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 556.1500000000001,
    y: 23.96
  }, "\n        Bertie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 583.97,
    y: 0,
    width: 57.4,
    height: 47.92,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.973333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 612.6700000000001,
    y: 23.96
  }, "\n        Lee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 641.37,
    y: 0,
    width: 58.63,
    height: 47.92,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.9933333333333336
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 670.6850000000001,
    y: 23.96
  }, "\n        Transylvania\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 33.93,
    y: 47.92,
    width: 55.84,
    height: 53.08,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.846666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 61.85,
    y: 74.46000000000001
  }, "\n        Martin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 33.93,
    y: 101,
    width: 55.84,
    height: 53.29,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.66125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 61.85,
    y: 127.645
  }, "\n        Mitchell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 33.93,
    y: 154.28,
    width: 55.84,
    height: 54.5,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.055555555555555
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 61.85,
    y: 181.53
  }, "\n        Brunswick\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 33.93,
    y: 208.78,
    width: 55.84,
    height: 56.62,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.306666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 61.85,
    y: 237.09
  }, "\n        Person\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 33.93,
    y: 265.4,
    width: 55.84,
    height: 57.89,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.306666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 61.85,
    y: 294.34499999999997
  }, "\n        Bladen\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 33.93,
    y: 323.29,
    width: 55.84,
    height: 59.25,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.168000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 61.85,
    y: 352.915
  }, "\n        Swain\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 33.93,
    y: 382.54,
    width: 55.84,
    height: 60.13,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.306666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 61.85,
    y: 412.605
  }, "\n        Onslow\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 33.93,
    y: 442.67,
    width: 55.84,
    height: 60.83,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.168000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 61.85,
    y: 473.08500000000004
  }, "\n        Vance\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 33.93,
    y: 503.5,
    width: 55.84,
    height: 64.82,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.204444444444444
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 61.85,
    y: 535.91
  }, "\n        Alexander\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 33.93,
    y: 568.32,
    width: 55.84,
    height: 65.43,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.168000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 61.85,
    y: 601.0350000000001
  }, "\n        Davie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 33.93,
    y: 633.75,
    width: 55.84,
    height: 66.25,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.204444444444444
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 61.85,
    y: 666.875
  }, "\n        Edgecombe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 89.77,
    y: 47.92,
    width: 57.59,
    height: 64.67,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.19875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 118.565,
    y: 80.255
  }, "\n        Richmond\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 147.36,
    y: 47.92,
    width: 57.9,
    height: 64.67,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.58
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 176.31,
    y: 80.255
  }, "\n        Macon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 205.26,
    y: 47.92,
    width: 60.7,
    height: 64.67,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.116666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 235.60999999999999,
    y: 80.255
  }, "\n        Craven\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 265.96,
    y: 47.92,
    width: 61.04,
    height: 64.67,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.173333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 296.47999999999996,
    y: 80.255
  }, "\n        Lenoir\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 327.01,
    y: 47.92,
    width: 61.36,
    height: 64.67,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.272
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 357.69,
    y: 80.255
  }, "\n        Anson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 388.36,
    y: 47.92,
    width: 61.56,
    height: 64.67,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.26
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 419.14,
    y: 80.255
  }, "\n        Yancey\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 449.93,
    y: 47.92,
    width: 61.72,
    height: 64.67,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.857777777777778
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 480.79,
    y: 80.255
  }, "\n        Granville\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 511.65,
    y: 47.92,
    width: 62.43,
    height: 64.67,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.405
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 542.865,
    y: 80.255
  }, "\n        Orange\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 574.07,
    y: 47.92,
    width: 62.9,
    height: 64.67,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.58
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 605.5200000000001,
    y: 80.255
  }, "\n        Moore\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 636.97,
    y: 47.92,
    width: 63.03,
    height: 64.67,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.87875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 668.485,
    y: 80.255
  }, "\n        Carteret\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 89.77,
    y: 112.59,
    width: 66.69,
    height: 61.3,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.13
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 123.115,
    y: 143.24
  }, "\n        Montgomery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 89.77,
    y: 173.89,
    width: 66.69,
    height: 62.19,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.77375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 123.115,
    y: 204.98499999999999
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 89.77,
    y: 236.08,
    width: 66.69,
    height: 63.2,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.028571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 123.115,
    y: 267.68
  }, "\n        Watauga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 89.77,
    y: 299.28,
    width: 66.69,
    height: 63.23,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.90375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 123.115,
    y: 330.895
  }, "\n        McDowell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 89.77,
    y: 362.51,
    width: 66.69,
    height: 65.76,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.394285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 123.115,
    y: 395.39
  }, "\n        Jackson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 89.77,
    y: 428.28,
    width: 66.69,
    height: 65.92,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.986666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 123.115,
    y: 461.23999999999995
  }, "\n        Yadkin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 89.77,
    y: 494.19,
    width: 66.69,
    height: 66.22,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.459999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 123.115,
    y: 527.3
  }, "\n        Halifax\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 89.77,
    y: 560.41,
    width: 66.69,
    height: 69.06,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.33625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 123.115,
    y: 594.9399999999999
  }, "\n        Cherokee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 89.77,
    y: 629.47,
    width: 66.69,
    height: 70.53,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.115
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 123.115,
    y: 664.735
  }, "\n        Wilson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 156.45,
    y: 112.59,
    width: 63.96,
    height: 75.25,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.8145454545454545
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 188.42999999999998,
    y: 150.215
  }, "\n        New_Hanover\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 220.42,
    y: 112.59,
    width: 65.13,
    height: 75.25,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.304285714285713
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 252.98499999999999,
    y: 150.215
  }, "\n        Lincoln\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 285.55,
    y: 112.59,
    width: 65.99,
    height: 75.25,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.427142857142856
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 318.545,
    y: 150.215
  }, "\n        Madison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 351.53,
    y: 112.59,
    width: 66.53,
    height: 75.25,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.392222222222222
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 384.79499999999996,
    y: 150.215
  }, "\n        Henderson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 62,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 418.06,
    y: 112.59,
    width: 68.17,
    height: 75.25,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 17.0425
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 452.145,
    y: 150.215
  }, "\n        Nash\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 63,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 486.22,
    y: 112.59,
    width: 69.54,
    height: 75.25,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.908000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 520.99,
    y: 150.215
  }, "\n        Burke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 64,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 555.76,
    y: 112.59,
    width: 71.63,
    height: 75.25,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.162999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 591.575,
    y: 150.215
  }, "\n        Cumberland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 65,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 627.39,
    y: 112.59,
    width: 72.61,
    height: 75.25,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.07625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 663.6949999999999,
    y: 150.215
  }, "\n        Beaufort\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 66,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 156.45,
    y: 187.84,
    width: 78.99,
    height: 71.72,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.953333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 195.945,
    y: 223.7
  }, "\n        Duplin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 67,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 156.45,
    y: 259.56,
    width: 78.99,
    height: 71.79,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.255714285714287
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 195.945,
    y: 295.455
  }, "\n        Chatham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 68,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 156.45,
    y: 331.35,
    width: 78.99,
    height: 72.09,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 14.418000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 195.945,
    y: 367.39500000000004
  }, "\n        Union\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 69,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 156.45,
    y: 403.44,
    width: 78.99,
    height: 72.43,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.05375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 195.945,
    y: 439.655
  }, "\n        Caldwell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 70,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 156.45,
    y: 475.86,
    width: 78.99,
    height: 73.67,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.278333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 195.945,
    y: 512.695
  }, "\n        Stokes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 71,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 156.45,
    y: 549.53,
    width: 78.99,
    height: 74.31,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.28875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 195.945,
    y: 586.685
  }, "\n        Columbus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 72,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 156.45,
    y: 623.85,
    width: 78.99,
    height: 76.15,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 19.0375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 195.945,
    y: 661.9250000000001
  }, "\n        Pitt\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 73,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 235.44,
    y: 187.84,
    width: 70.93,
    height: 85.88,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.132857142857144
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 270.905,
    y: 230.78
  }, "\n        Harnett\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 74,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 306.37,
    y: 187.84,
    width: 75.54,
    height: 85.88,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 18.885
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 344.14,
    y: 230.78
  }, "\n        Ashe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 75,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 381.91,
    y: 187.84,
    width: 77.29,
    height: 85.88,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.041428571428572
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 420.555,
    y: 230.78
  }, "\n        Haywood\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 76,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 459.2,
    y: 187.84,
    width: 79.93,
    height: 85.88,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.321666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 499.16499999999996,
    y: 230.78
  }, "\n        Stanly\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 77,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 539.12,
    y: 187.84,
    width: 80.24,
    height: 85.88,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 16.048
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 579.24,
    y: 230.78
  }, "\n        Wayne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 78,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 619.36,
    y: 187.84,
    width: 80.64,
    height: 85.88,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.52
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 659.6800000000001,
    y: 230.78
  }, "\n        Sampson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 79,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 235.44,
    y: 273.72,
    width: 85.26,
    height: 84.5,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.38888888888889
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 278.07,
    y: 315.97
  }, "\n        Cleveland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 80,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 235.44,
    y: 358.21,
    width: 85.26,
    height: 84.73,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.473
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 278.07,
    y: 400.575
  }, "\n        Rockingham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 81,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 235.44,
    y: 442.95,
    width: 85.26,
    height: 85.27,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.21
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 278.07,
    y: 485.585
  }, "\n        Durham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 82,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 235.44,
    y: 528.21,
    width: 85.26,
    height: 85.59,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.526
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 278.07,
    y: 571.005
  }, "\n        Rutherford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 83,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 235.44,
    y: 613.8,
    width: 85.26,
    height: 86.2,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.180000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 278.07,
    y: 656.9
  }, "\n        Robeson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 84,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 320.7,
    y: 273.72,
    width: 86.81,
    height: 86,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.75
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 364.105,
    y: 316.72
  }, "\n        Cabarrus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 85,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 407.51,
    y: 273.72,
    width: 93.55,
    height: 86,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.75
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 454.28499999999997,
    y: 316.72
  }, "\n        Alamance\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 86,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 501.06,
    y: 273.72,
    width: 98.64,
    height: 86,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 17.2
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 550.38,
    y: 316.72
  }, "\n        Surry\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 87,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 599.7,
    y: 273.72,
    width: 100.3,
    height: 86,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 14.333333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 649.85,
    y: 316.72
  }, "\n        Wilkes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 88,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 320.7,
    y: 359.72,
    width: 106.7,
    height: 82.5,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.785714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 374.05,
    y: 400.97
  }, "\n        Catawba\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 89,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 320.7,
    y: 442.22,
    width: 106.7,
    height: 85.13,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 17.026
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 374.05,
    y: 484.785
  }, "\n        Rowan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 90,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 320.7,
    y: 527.36,
    width: 106.7,
    height: 85.69,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.241428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 374.05,
    y: 570.205
  }, "\n        Iredell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 91,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 320.7,
    y: 613.04,
    width: 106.7,
    height: 86.96,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.87
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 374.05,
    y: 656.52
  }, "\n        Davidson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 92,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 427.4,
    y: 359.72,
    width: 88.7,
    height: 106.2,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.783333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 471.75,
    y: 412.82000000000005
  }, "\n        Gaston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 93,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 516.1,
    y: 359.72,
    width: 91.87,
    height: 106.2,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.351818181818182
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 562.0350000000001,
    y: 412.82000000000005
  }, "\n        Mecklenburg\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 94,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 607.97,
    y: 359.72,
    width: 92.03,
    height: 106.2,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.50375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 653.985,
    y: 412.82000000000005
  }, "\n        Randolph\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 95,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 427.4,
    y: 465.92,
    width: 96.91,
    height: 110.34,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.11375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 475.85499999999996,
    y: 521.09
  }, "\n        Johnston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 96,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 427.4,
    y: 576.26,
    width: 96.91,
    height: 123.74,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 24.2275
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 475.85499999999996,
    y: 638.13
  }, "\n        Wake\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 97,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 524.3,
    y: 465.92,
    width: 87.18,
    height: 153.93,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.454285714285716
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 567.89,
    y: 542.885
  }, "\n        Forsyth\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 98,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 611.49,
    y: 465.92,
    width: 88.51,
    height: 153.93,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.06375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 655.745,
    y: 542.885
  }, "\n        Buncombe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 99,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 524.3,
    y: 619.85,
    width: 175.7,
    height: 80.15,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.01875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 612.15,
    y: 659.9250000000001
  }, "\n        Guilford\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1916);
export default __webpack_public_path__ + "static/media/1916.ecc2bcaf206e60a1804d72ca44408503.svg";
export { ForwardRef as ReactComponent };